import React, { FC, PropsWithChildren } from 'react';
import classnames from 'classnames';

import styles from './Menu.module.css';

interface MenuProps {
    className?: string;
    setMenuRef?: (element?: Element | null | undefined) => void;
}

export const Menu: FC<PropsWithChildren<MenuProps>> = ({ children, className, setMenuRef }) => (
    <div ref={setMenuRef} className={classnames(styles.root, className)}>
        {children}
    </div>
);
